import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  FormGroup,
  FormControlLabel,
  Snackbar,
  Checkbox,
  Chip,
  Autocomplete,
  TextField,
} from "@mui/material";
import CustomButton from "../../ui/button/Button";
import { useState, useEffect } from "react";

const ModalExcelAsignaciones = ({ open, onClose, onConfirm, companies }) => {
  const [empresasSeleccionadas, setEmpresasSeleccionadas] = useState([]);
  const [selected, setSelected] = useState({
    incluirLevantamientos: false,
    incluirEntregables: false,
    incluirMantenimientos: false,
  });

  const handleClose = () => {
    setSelected({
      incluirLevantamientos: false,
      incluirEntregables: false,
      incluirMantenimientos: false,
    });
    setEmpresasSeleccionadas([]);
    onClose();
  };

  const handleConfirm = () => {
    onConfirm({
      empresas: empresasSeleccionadas,
      ...selected,
    });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Generar Excel de Asignaciones</DialogTitle>
      <DialogContent>
        <div>
          <label style={{ marginBottom: "10px" }} className="form-label">
            Seleccionar empresas:
          </label>
          <Autocomplete
            multiple
            size="small"
            options={companies}
            getOptionLabel={(option) => option.razonSocial}
            renderInput={(params) => (
              <TextField {...params} label="Empresas seleccionadas" />
            )}
            onChange={(event, newValue) => {
              setEmpresasSeleccionadas(newValue);
            }}
          />
          <label
            className="form-label form-label-left"
            title="Seleccionar ninguno hará necesario ingresar esta información manualmente en el Excel."
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              marginTop: "20px",
            }}
          >
            Seleccionar fases a incluir
            <svg
              style={{ cursor: "pointer", marginLeft: "5px" }}
              xmlns="http://www.w3.org/2000/svg"
              height="18px"
              viewBox="0 -960 960 960"
              width="18px"
              fill="#666666"
            >
              <path d="M480-240q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-36-153h73q0-37 6.5-52.5T555-485q35-34 48.5-58t13.5-53q0-55-37.5-89.5T484-720q-51 0-88.5 27T343-620l65 27q9-28 28.5-43.5T482-652q28 0 46 16t18 42q0 23-15.5 41T496-518q-35 32-43.5 52.5T444-393Zm36 297q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
            </svg>
          </label>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selected.incluirLevantamientos}
                  onChange={() => {
                    setSelected({
                      ...selected,
                      incluirLevantamientos: !selected.incluirLevantamientos,
                    });
                  }}
                />
              }
              label="Levantamiento"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={selected.incluirEntregables}
                  onChange={() => {
                    setSelected({
                      ...selected,
                      incluirEntregables: !selected.incluirEntregables,
                    });
                  }}
                />
              }
              label="Implementación"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={selected.incluirMantenimientos}
                  onChange={() => {
                    setSelected({
                      ...selected,
                      incluirMantenimientos: !selected.incluirMantenimientos,
                    });
                  }}
                  id="mantenimiento"
                />
              }
              label={
                <label
                  className="form-label form-label-left"
                  title="Los mantenimientos siempre se crean como asignaciones nuevas."
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    margin: "0px",
                    cursor: "pointer",
                  }}
                  htmlFor="mantenimiento"
                >
                  Mantenimiento
                  <svg
                    style={{ cursor: "pointer", marginLeft: "5px" }}
                    xmlns="http://www.w3.org/2000/svg"
                    height="18px"
                    viewBox="0 -960 960 960"
                    width="18px"
                    fill="#666666"
                  >
                    <path d="M480-240q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-36-153h73q0-37 6.5-52.5T555-485q35-34 48.5-58t13.5-53q0-55-37.5-89.5T484-720q-51 0-88.5 27T343-620l65 27q9-28 28.5-43.5T482-652q28 0 46 16t18 42q0 23-15.5 41T496-518q-35 32-43.5 52.5T444-393Zm36 297q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
                  </svg>
                </label>
              }
            />
          </FormGroup>
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Aceptar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={handleConfirm}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalExcelAsignaciones;
